module.exports = __webpack_public_path__ + "static/media/img11.8be3fb1a.jpeg";